import * as axios from 'axios';
import { getAuthHeader } from '../utils';

export const getList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-status/list`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    });
}

export const getActiveList = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-status/active-list`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    });
}

export const addDetail = (model: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-status/add`;
    return axios.post(url, model, getAuthHeader())
        .then((response: any) => {
            return response.data;
        });
}

export const updateDetail = (model: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-status/update`;
    return axios.put(url, model, getAuthHeader())
        .then((response: any) => {
            return response.data;
        });
}